// extracted by mini-css-extract-plugin
module.exports = {"search":"Input_search__3Dgkq"};